<div class="cv-multiselect-component wrapper">
	<label *ngIf="label && label.length > 0">
		{{label}} <span class="required-text" *ngIf="required">*</span>
	</label>
	<button #dropdownButton
		class="btn btn-outline-secondary dropdown-trigger action-toggle"
		[ngClass]="{
			'open_btn': isOpen, 
			'input-invalid': (!isValid() || !valid)
		}"
		[attr.disabled]="disabled ? 'disabled' : null"
		[ngStyle]="{ width: width }"
		(click)="toggleMenu()">

		<button class="clear-button action-clear" (click)="clearValues()" *ngIf="currentValues.length > 0">
			<i class="fa fa-times dropdown-icon"></i>
		</button>
		<label class="title_lbl"
			[ngClass]="{
				'values_lbl': currentValues.length > 0, 
				'placeholder': currentValues.length === 0
			}">
			{{ (currentValues.length === 0) ? placeholder : ((currentValues.length > 1) ? 'Selected' : currentValues[0][optionText]) }}
			{{(currentValues.length > 1 ? ' (' + currentValues.length + ')' : '')}}
		</label>
		<i class="fa dropdown-icon" [ngClass]="{'fa-caret-down': !isOpen, 'fa-caret-up': isOpen}"></i>
	</button>

	<div #dropdownMenu 
		class="dropdown-menu"
		[ngStyle]="{ width: width }">

		<div *ngFor="let option of options" class="dropdown-item">
			<input class="action-select"
				type="checkbox"
				id="{{randomID}}-{{option[optionValue]}}"
				[checked]="isOptionSelected(option)"
				(change)="toggleOption($event, option)"/>

			<label class="item-value" 
				for="{{randomID}}-{{option[optionValue]}}"
				[ngClass]="{'checked-label': isOptionSelected(option)}">
				{{option[optionText]}}
			</label>
		</div>
	</div>

</div>
